import React from "react";

import PageHero from "components/site/PageHero";
import RevealBlock from "components/site/RevealBlock";
import { Col, Container, Row } from "components/site/SitePrimitives";
import SiteShell from "components/site/SiteShell";
import {
  buildStructuredData,
  focusAreasPage,
} from "content/siteContent";
import usePageMeta from "hooks/usePageMeta";

function FocusAreas() {
  usePageMeta({
    ...focusAreasPage.meta,
    structuredData: buildStructuredData({
      pageName: "Focus Areas",
      description: focusAreasPage.meta.description,
      path: focusAreasPage.meta.path,
    }),
  });

  return (
    <SiteShell pageClassName="ignitum-site-page ignitum-focus-page">
      <PageHero
        aside={
          <RevealBlock variant="card">
            <p className="site-panel-label">What guides scope</p>
            <ul className="site-signal-list">
              {focusAreasPage.hero.signals.map((signal) => (
                <li key={signal}>{signal}</li>
              ))}
            </ul>
          </RevealBlock>
        }
        compact
        description={focusAreasPage.hero.description}
        eyebrow={focusAreasPage.hero.eyebrow}
        title={focusAreasPage.hero.title}
      />

      <section className="site-section">
        <Container>
          <Row className="site-card-grid">
            {focusAreasPage.areas.map((area, index) => (
              <Col key={area.title} lg="6">
                <RevealBlock delay={index * 70} variant="card">
                  <div className="site-card site-split-card">
                    <p className="site-card-label">{area.label}</p>
                    <h3>{area.title}</h3>
                    <div className="site-kv">
                      {area.rows.map((row) => (
                        <div className="site-kv-row" key={row.label}>
                          <strong>{row.label}</strong>
                          <p>{row.text}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </RevealBlock>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="site-section site-section-muted">
        <Container>
          <RevealBlock className="site-section-intro" variant="lift">
            <p className="site-eyebrow">Broader capability</p>
            <h2>{focusAreasPage.breadth.title}</h2>
            <p>{focusAreasPage.breadth.description}</p>
          </RevealBlock>
          <Row className="site-card-grid">
            {focusAreasPage.breadth.items.map((item, index) => (
              <Col key={item.title} md="6">
                <RevealBlock delay={index * 70} variant="card">
                  <div className="site-card">
                    <p className="site-card-label">{item.label}</p>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </RevealBlock>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </SiteShell>
  );
}

export default FocusAreas;
